import React from 'react'
import { withTranslation } from 'react-i18next/hooks'

import theme from '../../../../theme'

import {Paper, Menu, MenuItem, ListItemIcon, ListItemText} from '@material-ui/core'

import { formatDateTime } from '../../../../api/date'

import GetAppIcon from '@material-ui/icons/GetApp'
import PlayArrowIcon from '@material-ui/icons/PlayArrow'
import { getBase64ID, getObjectByID } from '../../../../api/helpers'
import { SortableTable } from '../../../../components/SortableTable'


class ReportCallRecordingList_ extends React.Component {

    constructor(props){
        super(props);
        this.state = {menuAnchor: null}

        this.tableRef = React.createRef()
    }

    eventName(event){

        switch(event){
            case 1: return 'VoicePttPrivate'
            case 3: return 'VoicePttGroup'
            case 11: return 'VideoPttPrivate'
            case 12: return 'VideoPttGroup'
        }

        return '-'
    }

    handleMenuClick_(itemID){
        this.setState({menuItemID: itemID});
    }

    handleMenuClick(event, itemID){
        this.setState({menuAnchor: event.currentTarget, menuItemID: itemID});
        event.stopPropagation();
    }

    handleMenuClose(){
        this.menuAnchor = null;
        this.setState({menuAnchor: null});
        return null;
    }

    handleMenuItemClick(action){
        
        const itemID = this.state.menuItemID

        let rows = this.tableRef.current.getSelectedRows()
        console.log('handleMenuItemClick')
        console.log(rows)
        console.log(rows.length)

        const row = getObjectByID(itemID, this.props.reportData.rows, 'euuid')

        this.handleMenuClose()
        this.props.onAction({
            type: action, 
            id: itemID, 
            rows: rows.length>0 ? rows : [row],
            version: getBase64ID()
        })
    }

    render(){
        const {t} = this.props

        const styles = {
            paper: {
              width: '100%',
              overflowX: 'auto',
            },
            head: {
                color: theme.palette.color.dialogTitle,
                backgroundColor: theme.palette.background.dialogTitle,
            }
        };


        let contextMenu = (  
            <Menu anchorEl={this.state.menuAnchor} keepMounted
                        open={Boolean(this.state.menuAnchor)} onClose={this.handleMenuClose.bind(this)}>
            <MenuItem onClick={()=>{this.handleMenuItemClick('RESOURCE_PLAY')}}>
                <ListItemIcon color="primary"><PlayArrowIcon/></ListItemIcon> 
                <ListItemText primary={t('Play')} />
            </MenuItem>
            <MenuItem onClick={()=>{this.handleMenuItemClick('RESOURCE_DOWNLOAD')}}>
                <ListItemIcon><GetAppIcon/></ListItemIcon>
                <ListItemText primary={t('Download')} />
            </MenuItem>
            </Menu>
        )

        let columns = [
            {
                label: t('EventType'),
                name: 'calltype',
                eval: (val)=>{return t(this.eventName(val))},
                allowSort: true,
            },
            {
                label: t('DateTime'),
                name: 'edt',
                eval: (val)=>{return formatDateTime(val, 'full_date')},
                allowSort: true,
            },
            {
                label: t('Source'),
                name: 'fromname',
                allowSort: true,
            },
            {
                label: t('Destination'),
                name: 'toname',
                allowSort: true,
            },
            {
                label: t('Duration_s'),
                name: 'duration',
                allowSort: true,
            }
        ]

        return(
            <Paper style={styles.paper}>

                <SortableTable 
                    t={t}
                    ref={this.tableRef}
                    rows={this.props.reportData.rows}
                    columns={columns}
                    version={this.props.reportData.version}
                    contextMenu={contextMenu}
                    contextMenuKey="euuid"
                    primaryKey="euuid"
                    onMenuClick={this.handleMenuClick.bind(this)}    
                    checkboxSelection
                />


{/** 
                <Table size="small">
                    
                    <TableHead>
                        <TableRow>
                            <TableCell style={styles.head}>{t('EventType')}</TableCell>
                            <TableCell style={styles.head}>{t('DateTime')}</TableCell>
                            <TableCell style={styles.head}>{t('Source')}</TableCell>
                            <TableCell style={styles.head}>{t('Destination')}</TableCell>
                            <TableCell style={styles.head}>{t('Duration_s')}</TableCell>
                            <TableCell style={styles.head}></TableCell>
                        </TableRow>
                    </TableHead>
                    
                    <TableBody>
                        {this.props.reportData.rows && this.props.reportData.rows.map((row,index)=>(
                            <TableRow key={index} 
                                style={this.getRowStyle(row.euuid, index)}
                                onClick={()=>{this.handleRowSelect(row.euuid)}}>

                                <TableCell>
                                    {t(this.eventName(row.calltype))}
                                </TableCell>
                                <TableCell>
                                    {formatDateTime(row.edt, 'full_date')}
                                </TableCell>
                                <TableCell>
                                    {row.fromname}
                                </TableCell>
                                <TableCell>
                                    {row.toname}
                                </TableCell>
                                <TableCell>
                                    {row.duration}
                                </TableCell>

                                <TableCell style={{width:40}}>
                                    <IconButton size="small" color="inherit" aria-label="add" component="span"
                                        onClick={event=>this.handleMenuClick(event, row.euuid)}>
                                        <MoreVert />
                                    </IconButton>
                                </TableCell>
                            </TableRow>
                        ))}
                        
                    </TableBody>

                    <Menu anchorEl={this.state.menuAnchor} keepMounted 
                        open={Boolean(this.state.menuAnchor)} onClose={this.handleMenuClose.bind(this)}>
                        <MenuItem onClick={()=>{this.handleMenuItemClick('RESOURCE_PLAY')}}>
                            <ListItemIcon color="primary"><PlayArrowIcon/></ListItemIcon> 
                            <ListItemText primary={t('Play')} />
                        </MenuItem>
                        <MenuItem onClick={()=>{this.handleMenuItemClick('RESOURCE_DOWNLOAD')}}>
                            <ListItemIcon><GetAppIcon/></ListItemIcon>
                            <ListItemText primary={t('Download')} />
                        </MenuItem>
                    </Menu>
                </Table>

                */}


            </Paper>
        );

    }

}

export const ReportCallRecordingList = withTranslation()(ReportCallRecordingList_);